// <div data-controller="sidebar" data-action="keydown.esc@window->sidebar#close">
//   <button data-action="click->sidebar#open">☰</button>
//   <div data-sidebar-target="drawer" class="hidden">
//     <div data-action="click->sidebar#close"><!-- backdrop --></div>
//     <div><!-- panel -->
//       <button data-action="click->sidebar#close">✕</button>
//     </div>
//   </div>
// </div>
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['drawer']

  open() {
    this.drawerTarget.classList.remove('hidden')
  }

  close() {
    this.drawerTarget.classList.add('hidden')
  }
}
